import { render, staticRenderFns } from "./HistorialEncuestasSISA.vue?vue&type=template&id=e626d85a&"
import script from "./HistorialEncuestasSISA.vue?vue&type=script&lang=js&"
export * from "./HistorialEncuestasSISA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports